import { useMemo } from 'react';
import { useBootstrapApiBase } from '../api';
import { CreditUsageTitle } from '../constants';
import { CreditUsage, CreditUsageType } from '../definition';

export function useCreditUsageItem(type: CreditUsageType): CreditUsage {
  const api = useBootstrapApiBase();
  return useMemo(() => {
    return {
      credit: api.data?.cost[type] ?? 0,
      title: CreditUsageTitle[type],
      type,
    };
  }, [type, api.data?.cost]);
}
